export interface StatusSimDTO {
    aStatusSimId? : number;
    aCarrierId? : number;
    aValue? : string;
    aNameStatus? : string;
}

export function renderDeviceStatus(statusText?: string, row?: { carrier?: string, carrierName?: string, deviceStatus?: number}): string {
    let badgeCarrier = '';
    if (row?.deviceStatus == 2) {
        statusText = 'Archived';
    } else {
        const carrier = row?.carrier || row?.carrierName;
        if (carrier) {
            badgeCarrier = `carrier ${carrier.replaceAll('&', '')} status-${row?.deviceStatus}`;
            if (statusText) {
                badgeCarrier += ` status-${statusText}`
            }
        }
        statusText = statusText || (row?.deviceStatus == 1 ? '*Active*' : !row?.deviceStatus ? '*Suspended*' : `Unknown (${row?.deviceStatus})`);
    }
    const badgeAccent = row?.deviceStatus == 1 ? 'success' : 'warning';
    return `<span class="badge ${badgeCarrier} bg-${badgeAccent}-subtle text-${badgeAccent}-emphasis">${statusText}</span>`;
}
